import React from 'react';
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import InfoIcon from '@material-ui/icons/Info'
import HomeOutlinedIcon from '@material-ui/icons/Home'

import Routes from './Router'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function Main() {
  const classes = useStyles()

  const gotoAbout = ()=>{
    window.location.replace('/about')
  }

  const goHome = ()=>{
    window.location.replace('/')
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{backgroundColor:'#0A3D62'}}>
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={goHome}>
            <HomeOutlinedIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Paper chat
          </Typography>
          
            <IconButton color="inherit" onClick={gotoAbout}>
              <InfoIcon />
            </IconButton>
        </Toolbar>
      </AppBar>


      <div>
          <Routes />
      </div>
    </div>
  );
}